import { instance } from "@/services/API";

const BATCH_URL = "/analytics/batch-price-estimate";

export const uploadBatchFile = (file, { signal, onUploaded }) => {
  const formData = new FormData();
  formData.append("file", file, file.name);
  return instance.post(BATCH_URL, formData, {
    responseType: "blob",
    signal,
    onUploadProgress: (event) => {
      if (event.total && event.loaded >= event.total) onUploaded();
    },
  });
};

export const fetchBatchRuns = async () => {
  const response = await instance.get(BATCH_URL);
  return response.data;
};

export const fetchBatchRunFile = async (id) => {
  const response = await instance.get(`${BATCH_URL}/${id}/file`, { responseType: "blob" });
  return response.data;
};

export const deleteBatchRun = (id) => instance.delete(`${BATCH_URL}/${id}`);

export const fetchBatchOutputConfig = async () => {
  const response = await instance.get(`${BATCH_URL}/config`);
  return response.data;
};

export const saveBatchOutputConfig = async (config) => {
  const response = await instance.put(`${BATCH_URL}/config`, config);
  return response.data;
};
